import {
  IS_DARK_MODE,
  SATELLITE_IMAGE,
  SHOW_TRAFFIC,
} from "constants/ActionTypes";

export const isDarkMode = () => {
  return {
    type: IS_DARK_MODE,
  };
};
export const satelliteImage = () => {
  return {
    type: SATELLITE_IMAGE,
  };
};
export const showTraffic = () => {
  return {
    type: SHOW_TRAFFIC,
  };
};
